import React, { useContext, useEffect } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import FeedbackContent from "../../components/feedback";
import { useLocation, useNavigate } from "react-router-dom";
import { appLogger } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import {
  enableChatbot,
  enableFeedback,
  enableBugReport,
  enableFeatureRequest,
} from "../../utils/config";

interface TabPanelProps {
  children?: any;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const messages: any = [];

function a11yProps(index: number, label: any) {
  messages.push(label);
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const Feedback = () => {
  const getLocation: any = useLocation();
  const navigate = useNavigate();
  appLogger.info({
    infoObj: {
      method: "Feedback",
      component: "feedback",
      fileName: "index.tsx",
      location: getLocation,
    },
  });
  const { contextProVersion } = useContext(UserContext) as UserLoginInfo;
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  // const defaultActiveTab =
  //   getLocation && getLocation.state?.pageType == "BUG_REPORT" ? 1 : 0;
  let defaultActiveTab = 0;
  if (
    getLocation &&
    getLocation.state &&
    getLocation.state.pageType == "BUG_REPORT"
  ) {
    defaultActiveTab = 1;
  } else if (
    getLocation &&
    getLocation.state &&
    getLocation.state.pageType == "FEATURE_REQUEST"
  ) {
    defaultActiveTab = 2;
  } else {
    defaultActiveTab = 0;
  }
  if (
    enableFeedback &&
    userEnabledFeatures?.enableFeedback &&
    !(
      (enableBugReport && userEnabledFeatures?.enableBugReport) ||
      (enableChatbot && userEnabledFeatures?.enableChatbot)
    ) &&
    !(enableFeatureRequest && userEnabledFeatures?.enableFeatureRequest)
  ) {
    defaultActiveTab = 0;
  } else if (
    !(enableFeedback && userEnabledFeatures?.enableFeedback) &&
    ((enableBugReport && userEnabledFeatures?.enableBugReport) ||
      (enableChatbot && userEnabledFeatures?.enableChatbot)) &&
    !(enableFeatureRequest && userEnabledFeatures?.enableFeatureRequest)
  ) {
    defaultActiveTab = 0;
  } else if (
    !(enableFeedback && userEnabledFeatures?.enableFeedback) &&
    !(
      (enableBugReport && userEnabledFeatures?.enableBugReport) ||
      (enableChatbot && userEnabledFeatures?.enableChatbot)
    ) &&
    enableFeatureRequest &&
    userEnabledFeatures?.enableFeatureRequest
  ) {
    defaultActiveTab = 0;
  }

  const [value, setValue] = React.useState(defaultActiveTab);
  const [stateValue, setstateValue] = React.useState(getLocation);

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
    navigate(location.pathname, { replace: true });
  };
  useEffect(() => {}, []);

  window.onload = () => {
    setValue(0);
    navigate(location.pathname, { replace: true });
    setstateValue("");
  };

  const renderIndex = (label: any) => {
    const data = [...new Set(messages)];
    return data.indexOf(label);
  };
  return (
    <div className="feedback-wrap">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="feedback / bug tabs"
        >
          {enableFeedback && userEnabledFeatures?.enableFeedback && (
            <Tab label="feedback" {...a11yProps(0, "feedback")} />
          )}
          {((enableBugReport && userEnabledFeatures?.enableBugReport) ||
            (enableChatbot && userEnabledFeatures?.enableChatbot)) && (
            <Tab label="tickets" {...a11yProps(1, "bugs")} />
          )}
          {enableFeatureRequest &&
            userEnabledFeatures?.enableFeatureRequest && (
              <Tab
                label="feature request"
                {...a11yProps(2, "feature request")}
              />
            )}
        </Tabs>
      </Box>
      <TabPanel value={value} index={renderIndex("feedback")}>
        <FeedbackContent pageType="FEEDBACK" stateValue={stateValue} />
      </TabPanel>
      <TabPanel value={value} index={renderIndex("bugs")}>
        <FeedbackContent pageType="BUG_REPORT" stateValue={stateValue} />
      </TabPanel>
      <TabPanel value={value} index={renderIndex("feature request")}>
        <FeedbackContent pageType="FEATURE_REQUEST" stateValue={stateValue} />
      </TabPanel>
    </div>
  );
};

export default React.memo(Feedback);
